import { Component, OnInit } from '@angular/core';
import { SxContextService } from '../../infrastructure/services/sxContext.service';
import { SubscriptionsService } from '../../infrastructure/services/subscriptions.service';
import { Observable } from 'rxjs/Observable';
import { ItemGeneralListado } from '../../helpers/components/itemClasses/itemListadoGeneral.class';
import { AlertService } from '../../infrastructure/services/alert.service';

@Component({
  templateUrl: 'settings.usuario.component.html'
})
export class SettingsUsuarioComponent implements OnInit {
  sistema: any;
  sistemas: Observable<ItemGeneralListado[]>;

  constructor(private sxContextService: SxContextService,
              private subscriptionsService: SubscriptionsService,
              private alertService: AlertService) { }

  ngOnInit() {
    // Inicializamos el dropdown con el sistema que hay guardado en el contexto
    this.sistema = this.sxContextService.getContexto();

    this.sistemas = this.subscriptionsService.getForList();
  }

  seleccionarSistema(sistema) {
    this.sistema = sistema.id;
  }

  resetearSeleccion() {
    this.sistema = null;
  }

  guardar() {
    if (!this.sistema) {
      this.sxContextService.removeContexto();
    } else {
      this.sxContextService.setContexto(this.sistema);
    }

    this.alertService.showSuccessMessage('EDITADO_CORRECTAMENTE');
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/settingsUsuario/settings.usuario.component.ts